// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import Element from 'element-ui'
import enLang from 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import axios from 'axios'
// 引入Echarts
//import echarts from 'echarts'
import  * as  echarts from 'echarts'
import router from './router'

import  './assets/css/common.css'
//import moment from "moment"

//import global_ from './Global.vue'

Vue.use(Element)
Vue.use(enLang)
//Vue.prototype.GLOBAL = global_;
//axios.defaults.baseURL=global_.BASE_URL;

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
//Vue.prototype.$moment = moment

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js